/**
 * True iff *err* is the backend's refusal to newly set a language the owner has
 * not released (`LANGUAGE_NOT_RELEASED`, ADR-111 D5 and its Amendment 1) as
 * `source_language` or `interface_language`.
 *
 * Chosen by the envelope's `code`, never its `detail` text, which is English
 * and written for developers (the rule of textExtractError.ts). The caller
 * shows its own localized message.
 */
export function isLanguageNotReleased(err: unknown): boolean {
  const detail = (err as { response?: { data?: { detail?: unknown } } } | null)
    ?.response?.data?.detail
  return (
    !!detail &&
    typeof detail === 'object' &&
    (detail as { code?: unknown }).code === 'LANGUAGE_NOT_RELEASED'
  )
}
